import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ClickAwayListener } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';

interface IconPopoverMenuProps {
    icon?: React.ReactNode; // Allow passing a custom icon, default to EditIcon
    iconButtonStyle?: React.CSSProperties; // Allow custom styles for the icon button
    onOptionClick: (option: 'edit' | 'delete' | 'duplicate') => void; // Callback for menu option selection
}

const IconPopoverMenu: React.FC<IconPopoverMenuProps> = ({ icon = <EditIcon />, iconButtonStyle, onOptionClick }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { themeStyle } = useThemeContext();

    const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        event.stopPropagation();
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleOptionClick = (option: 'edit' | 'delete' | 'duplicate') => {
        onOptionClick(option);
        handleMenuClose();
    };

    return (
        <>
            {/* Icon Button */}
            <IconButton onClick={handleMenuClick} style={iconButtonStyle} size="small">
                {icon}
            </IconButton>

            {/* Popover Menu */}
            <ClickAwayListener onClickAway={() => handleMenuClose()}>
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={() => handleMenuClose()}
                    sx={{
                        zIndex: 9999,
                    }}
                    PaperProps={{
                        sx: {
                            backgroundColor: theme[themeStyle].deep_grey_lighter, // 🔥 Ensures menu bg is black
                        },
                    }}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}>
                    <MenuItem sx={{ color: theme[themeStyle].tag_white }} onClick={() => handleOptionClick('edit')}>
                        Edit
                    </MenuItem>
                    <MenuItem sx={{ color: theme[themeStyle].tag_white }} onClick={() => handleOptionClick('delete')}>
                        Delete
                    </MenuItem>
                    <MenuItem
                        sx={{ color: theme[themeStyle].tag_white }}
                        onClick={() => handleOptionClick('duplicate')}>
                        Duplicate
                    </MenuItem>
                </Menu>
            </ClickAwayListener>
        </>
    );
};

export default IconPopoverMenu;
